package demos.loading

import androidx.compose.animation.core.*
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.*
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp


const val SPINNING_CIRCLE_LOADER = "dff31b3a2db8866c48571784a35ae33c9fb98161b5c523348c6c08952f7a7853"

@Composable
fun SpinningCircleLoader() {

    Box(Modifier.size(100.dp)) {
        SpinningCircle(
            color = Color(0xff9A7DDE),
            rotation = 0f,
        )
        SpinningCircle(
            color = Color(0xff97CE64),
            rotation = 45f,
        )
        SpinningCircle(
            color = Color(0xffFFF689),
            rotation = -45f,
        )
    }
}

@Composable
fun SpinningCircle(
    color: Color,
    rotation: Float,
) {

    val spinAnimation = rememberInfiniteTransition()
    val spinAnimationDegrees by spinAnimation.animateFloat(
        initialValue = 0f,
        targetValue = 360f,
        animationSpec = infiniteRepeatable(
            animation = tween(3_000, easing = LinearEasing),
        )
    )

    val rotateAnimation = rememberInfiniteTransition()
    val rotateAnimationDegrees by rotateAnimation.animateFloat(
        initialValue = 0f,
        targetValue = 360f,
        animationSpec = infiniteRepeatable(
            animation = tween(10_000, easing = LinearEasing),
        )
    )

    Box(
        Modifier
            .fillMaxSize()
            .rotate(rotateAnimationDegrees)
            .rotate(rotation)
            .graphicsLayer {
                cameraDistance = Float.POSITIVE_INFINITY
                rotationX = spinAnimationDegrees
            }
    ) {

        Box(
            Modifier
                .fillMaxSize()
                .scale(1.5f)
                .alpha(.1f)
                .border(Dp.Hairline, Color.White, CircleShape)
        )

        Box(
            Modifier
                .fillMaxSize()
                .blur(15.dp, edgeTreatment = BlurredEdgeTreatment.Unbounded)
                .alpha(.2f)
                .border(
                    width = 15.dp,
                    color = color,
                    shape = CircleShape,
                )
        )

        Box(
            Modifier
                .fillMaxSize()
                .border(
                    width = 15.dp,
                    color = color,
                    shape = CircleShape,
                )
        )
    }
}